import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/newDoc.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleCreatedEvent } from './Types'

interface Props extends ActivityEventPosition {
  event: ArticleCreatedEvent
}

const ArticleCreated = ({ event, ...props }: Props) => {
  const {
    user,
    data: { status_name, status_color },
  } = event

  return (
    <BaseActivityEvent
      {...props}
      icon={<Icon />}
      timestamp={event.timestamp}
      status={status_name && status_color ? { name: status_name, color: status_color } : undefined}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> created this doc
        </>
      }
    />
  )
}

export { ArticleCreated }
